import { createContext } from 'react';
import type { i18n } from 'i18next';

export interface TranslationContextType {
  t: (x: string, y?: object) => string;
  i18n: i18n | null;
}

const TranslationContext = createContext<TranslationContextType>({
  t: (key) => key,
  i18n: null,
});

export default TranslationContext;
